<app-page-header></app-page-header>
<app-breadcromb pageName="Selection Form"></app-breadcromb>

<!--div *ngIf="!name; else forminfo"-->
    <div class="container-fluid">
        <h1>El-Form</h1>
        <form>
          <div class="form-group">
            <label>1. Do you have immediate family member/s in Telone?, Give nature of relationship and the department they work under.</label>
            <input type="text" class="form-control" />
          </div>

          <div class="mb-3">
            <label>2. Have you worked for TelOne before?</label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" />
              <label class="form-check-label"> Yes</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" />
              <label class="form-check-label"> No</label>
            </div>
          </div>

          <div class="form-group">
            <select class="custom-select">
              <option selected>If Yes, what was the reason for leaving? </option>
              <option *ngFor="let topic of topics">{{ topic }}</option>
            </select>
          </div>

          <div class="mb-3">
            <label>3. Have you ever been convicted of a felony?</label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" />
              <label class="form-check-label"> Yes</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" />
              <label class="form-check-label"> No</label>
            </div>

            <div class="form-group">
                <label>If Yes, state the case: </label>
                <input type="text" class="form-control" />
              </div>
      
              <button class="btn btn-primary" type="submit">Submit Answers</button>
      
            </div>
      
    <!--<form [formGroup]="rForm" (ngSubmit)="addPost(rForm.value)">
        <div class="form-container">
            <div class="row columns">
                <h1>My Form</h1>

                <label>Name
                    <input type="text" formControlName="name">
                </label>
                <div class="alert" *ngIf="!rForm.controls['name'].valid && rForm.controls['name'].touched">{{ titleAlert }}</div>

                <label>Description
                    <textarea formControlName="description"></textarea>
                </label>
                <div class="alert" *ngIf="!rForm.controls['description'].valid && rForm.controls['description'].touched"> Specify a description between 30 and 500 characters</div>

                <label for="validate">Minimum of 3 characters</label>
                <input type="checkbox" name="validate" formControlName="validate" value="1">Review

                <input type="submit" class="button expanded" value="Submit Form" [disabled]="!rForm.valid">
            </div>
        </div-->
    </form>
</div>

<!--ng-template #forminfo>
    <div class="form-container">
        <div class="row columns">
            <h1>{{ name }}</h1>          
    
            <p>{{ description }}</p>
        </div>
    </div>
</ng-template-->

